"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.StatsButton = exports.StatsItemSubtitle = exports.StatsItemTitle = exports.StatsItem = exports.StatsList = exports.Subtitle = exports.Title = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../Layout");

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Button = _interopRequireDefault(require("../Button"));

var Title = (0, _styled.default)('h3')(function (_ref) {
  var space = _ref.theme.space;
  return {
    fontSize: '2.8rem',
    lineHeight: '3.6rem',
    fontWeight: 'bold',
    margin: "0 0 ".concat(space.small)
  };
});
exports.Title = Title;
var Subtitle = (0, _styled.default)('p')({
  fontSize: '1.8rem',
  lineHeight: '2.2rem',
  marginBottom: '0'
});
exports.Subtitle = Subtitle;
var StatsList = (0, _styled.default)(_Layout.Grid)(function (_ref2) {
  var space = _ref2.theme.space;
  return _defineProperty({
    width: '100%',
    justifyContent: 'space-between',
    marginTop: space.xlarge
  }, _mediaQueries.default.medium, {
    marginTop: space.xxlarge
  });
});
exports.StatsList = StatsList;
var StatsItem = (0, _styled.default)('div')(function (_ref4) {
  var space = _ref4.theme.space;
  return _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: space.xlarge
  }, _mediaQueries.default.large, {
    marginBottom: 0
  });
});
exports.StatsItem = StatsItem;
var StatsItemTitle = (0, _styled.default)('div')({
  fontSize: '3.2rem',
  lineHeight: '3.2rem',
  fontWeight: 'bold'
});
exports.StatsItemTitle = StatsItemTitle;
var StatsItemSubtitle = (0, _styled.default)('div')(function (_ref6) {
  var space = _ref6.theme.space;
  return {
    fontSize: '1.8rem',
    lineHeight: '2.6rem',
    marginTop: space.medium
  };
});
exports.StatsItemSubtitle = StatsItemSubtitle;
var StatsButton = (0, _styled.default)(_Button.default)(function (_ref7) {
  var _ref8;

  var space = _ref7.theme.space;
  return _ref8 = {
    margin: "".concat(space.small, " auto 0")
  }, _defineProperty(_ref8, _mediaQueries.default.small, {
    margin: "".concat(space.large, " auto 0")
  }), _defineProperty(_ref8, _mediaQueries.default.large, {
    margin: "".concat(space.xlarge, " auto 0")
  }), _ref8;
});
exports.StatsButton = StatsButton;